import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import EasyAdminLogo from '../Images/EasyAdminLogo.png';
import '../Styles/button.css'
import '../Styles/Navbar.css';

function Navigationbar() {
  const navigate = useNavigate();
  const { logout, isAdmin, currentUser } = useAuth();

  const commonLinkStyle = {
    color: '#FD6925',
    fontFamily: 'header-font'
  };
  


  const onSignIn = () => {
    navigate('/sign-in')
  }
  const onAdminPanelClick = () => {
    navigate('/admin-panel')
  }
  const onProfileClick = () => {
    navigate('/profile')
  }
  const onPortalClick = () => {
    navigate('/valuator')
  }


  const renderLoginSignupButtons = () => {
    if (currentUser === null) {
      return (
        <React.Fragment>
          <button onClick={onSignIn} className="login-btn">Login</button>
        </React.Fragment>
      );
    } else {
      return (
        <button className="delete-btn" onClick={logout}>
          {currentUser.displayName ? `Logud (${currentUser.displayName})` : 'Logud'}
        </button>
      );
    }
  };

  const renderAdminPortal = () => {
    if (isAdmin === true) {
      return (
        <button onClick={onPortalClick} className="generic-ea-btn me-5" >ValuatorAPP</button>
      );
    }
    return null;
  }

  const renderAdminLink = () => {
    if (isAdmin === true) {
      return (
        <button onClick={onAdminPanelClick} className="generic-ea-btn" >Admin Panel</button>
      );
    }
    return null;
  };
  const renderProfileLink = () => {
    if (currentUser){
      return (
        <button onClick={onProfileClick} className='generic-ea-btn'>Profil</button>
      );
    }
    return null;
  }



  return (
    <nav className="custom-navbar">
            <div className='navbar-container'>
            <Link to='/' className='navbar-logo'>
          <img className='navbar-logo' src={EasyAdminLogo} alt='logo'></img>
        </Link>
        <ul className='navbar-nav2'>
          <li className='nav-item2'>
            <Link to='/' className='nav-link2'>
              Hjem
            </Link>
          </li>
          <li className='nav-item2'>
            <Link to='/månedsrapport' className='nav-link2'>
              Månedsrapport
            </Link>
          </li>
          <li className='nav-item2'>
            <Link to='/Strategi' className='nav-link2'>
              Strategi
            </Link>
          </li>
          <li className='nav-item2'>
            <Link to='/Rollefordeling' className='nav-link2'>
              Roller
            </Link>
          </li>
          </ul>
                <div className="navbar-buttons">
                    {renderAdminPortal()}
                    {renderAdminLink()}
                    {renderProfileLink()}
                    {renderLoginSignupButtons()}
                </div>
            </div>
        </nav>
  );
}

export default Navigationbar;
